import _regeneratorRuntime from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { Base64 } from 'js-base64';
import { ethers, BigNumber } from 'ethers';
export { checkProperties, deepCopy, defineReadOnly, getStatic, resolveProperties, shallowCopy } from '@ethersproject/properties';
import { isHexString, isBytes } from 'ethers/lib/utils';

var base64Encode = function base64Encode(val) {
  return Base64.encode(val, true);
};

var base64EncodeObject = function base64EncodeObject(obj) {
  return Base64.encode(JSON.stringify(obj), true);
};

var base64Decode = function base64Decode(encodedString) {
  if (encodedString === null || encodedString === undefined) {
    return undefined;
  }

  return Base64.decode(encodedString);
};

var base64DecodeObject = function base64DecodeObject(encodedObject) {
  if (encodedObject === null || encodedObject === undefined) {
    return undefined;
  }

  return JSON.parse(Base64.decode(encodedObject));
};

var encodeMessageDigest = function encodeMessageDigest(message) {
  if (typeof message === 'string') {
    return ethers.utils.arrayify(ethers.utils.keccak256(ethers.utils.toUtf8Bytes(message)));
  } else {
    return ethers.utils.arrayify(ethers.utils.keccak256(message));
  }
}; // packMessageData encodes the specified data ready for the Sequence Wallet contracts.


var packMessageData = function packMessageData(walletAddress, chainId, digest) {
  return ethers.utils.solidityPack(['string', 'uint256', 'address', 'bytes32'], ['\x19\x01', chainId, walletAddress, digest]);
};

var subDigestOf = function subDigestOf(address, chainId, digest) {
  return ethers.utils.keccak256(packMessageData(address, chainId, digest));
};

var isNode = function isNode() {
  if (typeof window === 'undefined' && typeof process === 'object') {
    return true;
  } else {
    return false;
  }
};

var isBrowser = function isBrowser() {
  return !isNode();
};

var jwtDecodeClaims = function jwtDecodeClaims(jwt) {
  var parts = jwt.split('.');

  if (parts.length !== 3) {
    throw new Error('invalid jwt');
  }

  var claims = JSON.parse(Base64.decode(parts[1]));
  return claims;
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var logLevel;

(function (logLevel) {
  logLevel[logLevel["DEBUG"] = 1] = "DEBUG";
  logLevel[logLevel["INFO"] = 2] = "INFO";
  logLevel[logLevel["WARN"] = 3] = "WARN";
  logLevel[logLevel["ERROR"] = 4] = "ERROR";
  logLevel[logLevel["DISABLED"] = 5] = "DISABLED";
})(logLevel || (logLevel = {}));

var Logger = /*#__PURE__*/function () {
  function Logger(config) {
    _classCallCheck(this, Logger);

    this.config = config;
    this.logLevel = void 0;
    this.configure(config);
  }

  _createClass(Logger, [{
    key: "configure",
    value: function configure(config) {
      this.config = _extends({}, this.config, config);

      switch (this.config.logLevel) {
        case 'DEBUG':
          this.logLevel = logLevel.DEBUG;
          break;

        case 'INFO':
          this.logLevel = logLevel.INFO;
          break;

        case 'WARN':
          this.logLevel = logLevel.WARN;
          break;

        case 'ERROR':
          this.logLevel = logLevel.ERROR;
          break;

        case 'DISABLED':
          this.logLevel = logLevel.DISABLED;
          break;

        default:
          this.logLevel = logLevel.INFO;
          break;
      }
    }
  }, {
    key: "debug",
    value: function debug(message) {
      if (this.logLevel === logLevel.DEBUG) {
        var _console;

        for (var _len = arguments.length, optionalParams = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          optionalParams[_key - 1] = arguments[_key];
        }

        (_console = console).log.apply(_console, [message].concat(optionalParams));
      }
    }
  }, {
    key: "info",
    value: function info(message) {
      if (this.logLevel <= logLevel.INFO) {
        var _console2;

        for (var _len2 = arguments.length, optionalParams = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          optionalParams[_key2 - 1] = arguments[_key2];
        }

        (_console2 = console).log.apply(_console2, [message].concat(optionalParams));
      }
    }
  }, {
    key: "warn",
    value: function warn(message) {
      if (this.logLevel <= logLevel.WARN) {
        var _console3;

        for (var _len3 = arguments.length, optionalParams = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          optionalParams[_key3 - 1] = arguments[_key3];
        }

        (_console3 = console).warn.apply(_console3, [message].concat(optionalParams));

        if (this.config.onwarn) {
          this.config.onwarn(message, optionalParams);
        }
      }
    }
  }, {
    key: "error",
    value: function error(message) {
      if (this.logLevel <= logLevel.ERROR) {
        var _console4;

        for (var _len4 = arguments.length, optionalParams = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          optionalParams[_key4 - 1] = arguments[_key4];
        }

        (_console4 = console).error.apply(_console4, [message].concat(optionalParams));

        if (this.config.onerror) {
          this.config.onerror(message, optionalParams);
        }
      }
    }
  }]);

  return Logger;
}();

var logger = new Logger({
  logLevel: 'INFO'
});

var configureLogger = function configureLogger(config) {
  return logger.configure(config);
};

function promisify(f, thisContext) {
  return function () {
    for (var _len5 = arguments.length, a = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      a[_key5] = arguments[_key5];
    }

    var args = Array.prototype.slice.call(a);
    return new Promise( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                args.push(function (err, result) {
                  return err ? reject(err) : resolve(result);
                });
                _context.next = 4;
                return f.apply(thisContext, args);

              case 4:
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);
                reject(_context.t0);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 6]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
  };
}

var getRandomInt = function getRandomInt() {
  var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_SAFE_INTEGER;
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

function queryStringFromObject(name, obj) {
  var k = encodeURIComponent(name);
  var v = encodeURIComponent(JSON.stringify(obj));
  return "".concat(k, "=").concat(v);
}

function queryStringToObject(qs) {
  var p = qs.split('&');
  var o = {};

  var _iterator = _createForOfIteratorHelper(p),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var v = _step.value;
      var z = v.split('=');
      o[decodeURIComponent(z[0])] = JSON.parse(decodeURIComponent(z[1]));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return o;
} // sanitizeNumberString accepts a number string and returns back a clean number string.
// For example, input '1234.5678' will return '1234.5678' but '12javascript:{}etc' will return '12'


var sanitizeNumberString = function sanitizeNumberString(numString) {
  if (!numString || typeof numString !== 'string') {
    return '';
  }

  var v = numString.match(/[\d.]+/);
  return v && v.length > 0 ? v[0].trim() : '';
}; // sanitizeAlphanumeric accepts any string and returns alphanumeric contents only


var sanitizeAlphanumeric = function sanitizeAlphanumeric(alphanum) {
  if (!alphanum || typeof alphanum !== 'string') {
    return '';
  }

  var v = alphanum.match(/[\w\s\d]+/);
  return v && v.length > 0 ? v[0].trim() : '';
}; // sanitizeHost accepts any string and returns valid host string


var sanitizeHost = function sanitizeHost(host) {
  if (!host || typeof host !== 'string') {
    return '';
  }

  var v = host.match(/[\w\d.\-:\/]+/);
  return v && v.length > 0 ? v[0].trim() : '';
};

var sleep = function sleep(t) {
  return new Promise(function (resolve) {
    var timeout = setTimeout(function () {
      clearTimeout(timeout);
      resolve();
    }, t);
  });
};

var encodeTypedDataHash = function encodeTypedDataHash(typedData) {
  var types = _extends({}, typedData.types); // remove EIP712Domain key from types as ethers will auto-gen it in
  // the hash encoder below


  delete types['EIP712Domain'];
  return ethers.utils._TypedDataEncoder.hash(typedData.domain, types, typedData.message);
};

var encodeTypedDataDigest = function encodeTypedDataDigest(typedData) {
  return ethers.utils.arrayify(encodeTypedDataHash(typedData));
}; // urlClean removes double slashes from url path


var urlClean = function urlClean(url) {
  return url.replace(/([^:]\/)\/+/g, '$1');
};

function isBigNumberish(value) {
  return value != null && (BigNumber.isBigNumber(value) || typeof value === "number" && value % 1 === 0 || typeof value === "string" && !!value.match(/^-?[0-9]+$/) || isHexString(value) || typeof value === "bigint" || isBytes(value));
}

export { Logger, base64Decode, base64DecodeObject, base64Encode, base64EncodeObject, configureLogger, encodeMessageDigest, encodeTypedDataDigest, encodeTypedDataHash, getRandomInt, isBigNumberish, isBrowser, isNode, jwtDecodeClaims, logger, packMessageData, promisify, queryStringFromObject, queryStringToObject, sanitizeAlphanumeric, sanitizeHost, sanitizeNumberString, sleep, subDigestOf, urlClean };